var _defs, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgDeactivateIcon = function SvgDeactivateIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "97px",
    height: "96px",
    viewBox: "0 0 97 96",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "0%",
    x2: "50%",
    y2: "100%",
    id: "linearGradient-1"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4525E",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DB3D49",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "path-2",
    x: 0,
    y: 0,
    width: 40,
    height: 40
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "10.0-Telecounselling",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "10.4.1.7-RM-/-Counsellors-----deactivate-counsellor",
    transform: "translate(-672, -299)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "04.Organisms/07.Card/03.Popup/No-subtext-Copy-2",
    transform: "translate(520, 259)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-12",
    transform: "translate(152.597, 40)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "url(#linearGradient-1)",
    cx: 48,
    cy: 48,
    r: 48
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    stroke: "#E2F2FF",
    opacity: 0.200000003,
    cx: 48,
    cy: 48,
    r: 39.5
  }), /*#__PURE__*/React.createElement("g", {
    id: "Icon",
    transform: "translate(28, 28)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-3",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-2"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Mask"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.27799474,7.80533848 L32.1946615,30.7220053 C32.4923725,31.0199114 32.5813987,31.4677802 32.4202523,31.8568967 C32.2591059,32.2460133 31.8794982,32.5000014 31.4583334,32.5000014 C31.1820009,32.5004473 30.9169307,32.3905287 30.7220053,32.1946615 L7.80533848,9.27799474 C7.41624589,8.86844859 7.42450448,8.22340509 7.82395479,7.82395479 C8.22340509,7.42450448 8.86844859,7.41624589 9.27799474,7.80533848 Z M9.15364578,13.9101562 C9.25709675,13.8228434 9.41019225,13.8293521 9.50585932,13.9251302 L13.8574218,18.2786458 C13.9223148,18.3435119 13.9482835,18.4377413 13.9257812,18.5266927 C13.4738961,20.3896377 13.9019285,22.3569203 15.0869846,23.863707 C16.2720407,25.3704938 18.0830325,26.2501078 20,26.25 C20.4967756,26.2502185 20.9918056,26.1912083 21.4746094,26.0742188 C21.5635608,26.0517165 21.6577902,26.0776852 21.7226563,26.1425782 L24.8131511,29.2324219 C24.8774254,29.2966391 24.9035837,29.3897126 24.8821739,29.4780113 C24.8607642,29.5663099 24.794882,29.6370665 24.7083334,29.6647136 C23.1803793,30.1586826 21.5849781,30.4123567 19.9791667,30.4166667 C16.8697917,30.4166667 13.8841146,29.5052084 11.1048177,27.7063802 C8.63802078,26.1106771 6.42578118,23.8444011 4.70638013,21.1536458 C4.24982036,20.4452782 4.26627892,19.5313141 4.7480468,18.8398437 C6.09374993,16.9134114 7.56575515,15.2649739 9.15364578,13.9101562 Z M19.9791667,9.58333328 C22.9947917,9.58333328 26.0546875,10.5305989 28.8300782,12.3222656 C31.3352865,13.9401041 33.5703126,16.203125 35.2929688,18.8671875 C35.7370776,19.5554726 35.7396205,20.4393794 35.2994792,21.1302083 C34.1003381,23.0192526 32.624733,24.7178224 30.9218751,26.1692709 C30.8183634,26.2560078 30.6657213,26.2492237 30.5703126,26.1536459 L26.1464844,21.7265625 C26.0815915,21.6616964 26.0556228,21.567467 26.078125,21.4785156 C26.5947881,19.3584023 25.9682717,17.1223255 24.4252518,15.5793055 C22.8822318,14.0362856 20.646155,13.4097692 18.5260417,13.9264323 C18.4368871,13.9491812 18.3423453,13.9231946 18.2773437,13.8580729 L15.2018229,10.782552 C15.1377763,10.7187771 15.111378,10.626354 15.1320794,10.538373 C15.1527808,10.4503919 15.2176211,10.3794367 15.3033854,10.3509114 C16.8104237,9.84472051 18.3893903,9.58551673 19.9791667,9.58333328 Z M15.9576426,20.500664 C16.0075712,20.4757734 16.0678087,20.485456 16.1074219,20.5247396 L19.4791667,23.8964844 C19.5184503,23.9360976 19.5281329,23.996335 19.5032422,24.0462636 C19.4783516,24.0961922 19.4244193,24.124716 19.3691406,24.1171875 C17.5742016,23.8378746 16.1660317,22.4297047 15.8867187,20.6347656 C15.8791902,20.579487 15.9077141,20.5255547 15.9576426,20.500664 Z M20.6328125,15.8828125 C22.4302773,16.1614294 23.8405237,17.5716758 24.1191406,19.3691406 C24.1270406,19.4247081 24.0984448,19.4790845 24.048185,19.5040666 C23.9979252,19.5290487 23.9373132,19.5190138 23.8977865,19.4791667 L20.5208333,16.1035156 C20.4810467,16.0636825 20.4713673,16.0027902 20.496841,15.9525832 C20.5223147,15.9023763 20.5771712,15.8742279 20.6328125,15.8828125 Z",
    id: "Combined-Shape",
    fill: "#FFEFF0",
    mask: "url(#mask-3)"
  }))))))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgDeactivateIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/deactivate-icon.9b1097a0.svg";
export { ForwardRef as ReactComponent };